<template>
    <div>
        <div class="card">
			<GameNav v-if="isTablet" class="fields__item"/>
            <div class="card__body">
				<div class="mines fields__item">
					<div v-if="!isTablet" class="mines__input-area">
						<div class="mines__label">Количество бомб</div>
						<RangeSlider class="mines__range" :model-value="+bomb" @update:model-value="val => bomb = val" :min="2" :max="24" :step="1" :disabled="(game.active || disableBtn)"/>
						<div class="mines__label">Размер игры:</div>
						<div class="mines__controls" :class="[(game.active || disableBtn) ? 'disabled' : '']">
							<div class="mines__controls-group">
								<button class="mines__control btn btn--primary" @click="typeBet('max')" type="button">MAX</button>
								<button class="mines__control btn btn--primary" @click="typeBet('min')" type="button">MIN</button>
							</div>
							<div class="mines__control-bet">
								<input v-model="bet"
									   @keyup="validateBet"
									   :disabled="(game.active || disableBtn)"
									   class="mines__control-input"
									   autocomplete="off"
									   placeholder="Сумма">
							</div>
							<div class="mines__controls-group">
								<button class="mines__control btn btn--primary" @click="typeBet('x2')" type="button">x2</button>
								<button class="mines__control btn btn--primary" @click="typeBet('/2')" type="button">/2</button>
							</div>
						</div>
						<button @click="startGameSocket" v-if="!game.active"
								class="btn btn--lg btn--primary mines__field">Начать игру</button>
						<button v-else-if="game.active && game.active_path <= 1"
								class="btn btn--lg btn--light mines__field"
								:class="[game.active ? 'disabled': '']">Выберите ячейку
						</button>
						<button v-else-if="game.active_path > 1 && game.win && !cashingOut"
								class="btn btn--lg btn--success mines__field"
								:class="[(loadBomb > 0 || disableBtnCashout) ? 'disabled': '']" @click="cashOut">Забрать&nbsp<u>{{ (bet * getActiveCoef()).toFixed(2)}}</u>
						</button>
						<button v-else-if="game.active_path > 1 && game.win && cashingOut"
								class="btn btn--lg btn--success mines__field"
								:class="[(loadBomb > 0 || disableBtnCashout) ? 'disabled': '']">Забрать&nbsp<u>{{ (bet * getActiveCoef()).toFixed(2)}}</u>
						</button>
						<button v-if="game.active"
								class="btn btn--lg btn--primary mines__field"
								:class="[(loadBomb > 0 || disableBtnCashout) ? 'disabled': '']" @click="autoSelect">Авто
						</button>
						<button v-if="errors.show"
								class="btn btn--lg btn--danger mines__field">{{ errors.message}}
						</button>
					</div>
					<div class="mines__output">
						<div class="mines__grid" :class="[!game.active ? 'disabled' : '']">
							<div class="mines__row" v-for="blockKey in 5">
								<template v-for="bombKey in 5">
									<div class="mines__cell mines__cell--success mines__cell--disabled" v-if="game.bombs[setCounterBombKeys(`${blockKey}_${bombKey}`)] === false && typeof game.selected_bombs[setCounterBombKeys(`${blockKey}_${bombKey}`)] === 'undefined'">
										<svg class="mines__cell-icon"><use href="#svg-icon-mines-success"></use></svg>
									</div>
									<div class="mines__cell mines__cell--danger mines__cell--disabled" v-else-if="game.bombs[setCounterBombKeys(`${blockKey}_${bombKey}`)] === true && typeof game.selected_bombs[setCounterBombKeys(`${blockKey}_${bombKey}`)] === 'undefined'">
										<svg class="mines__cell-icon"><use href="#svg-icon-mines-danger"></use></svg>
									</div>
									<div class="mines__cell mines-sq" v-else-if="typeof game.selected_bombs[setCounterBombKeys(`${blockKey}_${bombKey}`)] === 'undefined'" @click="setBomb(setCounterBombKeys(`${blockKey}_${bombKey}`))">
										<div class="mines__cell-loader" v-if="loadBomb === setCounterBombKeys(`${blockKey}_${bombKey}`)"></div>
									</div>
									<div class="mines__cell mines__cell--success" v-else-if="game.selected_bombs[setCounterBombKeys(`${blockKey}_${bombKey}`)] === false">
										<svg class="mines__cell-icon"><use href="#svg-icon-mines-success"></use></svg>
									</div>
									<div class="mines__cell mines__cell--danger" v-else-if="game.selected_bombs[setCounterBombKeys(`${blockKey}_${bombKey}`)] === true">
										<svg class="mines__cell-icon"><use href="#svg-icon-mines-danger"></use></svg>
									</div>
								</template>
							</div>
						</div>
						<div class="mines__steps">
							<div class="steps-slider">
								<svg class="steps-slider__arrow" @click="slidePrev">
									<use href="#svg-icon-slider-prev"></use>
								</svg>
								<swiper class="steps-slider__carousel"
									:slides-per-view="2"
									:space-between="0"
									@swiper="onSwiper"
									:grab-cursor="true"
								>
									<template v-for="(totalMines, key) in mines[bomb - 2]">
										<swiper-slide class="steps-slider__slide" v-for="(mine, counter) in totalMines">
											<div class="steps-slider__slide-inner" :class="[(game.active_path === ((key * 2) + (counter + 1)) && game.win && !changeBombs) ? 'active' : '', (((key * 2) + (counter + 1)) < game.active_path && !changeBombs) ? 'success' : '', (game.active_path === ((key * 2) + (counter + 1)) && !game.win && !changeBombs) ? 'danger' : '']">
												<span class="steps-slider__slide-label">Шаг {{ (key * 2) + (counter + 1) }}</span>
												<span class="steps-slider__slide-title">{{ (bet * mine).toFixed(2) }}</span>
												<span class="steps-slider__slide-subtitle">x{{ mine }}</span>
											</div>
										</swiper-slide>
									</template>
								</swiper>
								<svg class="steps-slider__arrow" @click="slideNext">
									<use href="#svg-icon-slider-next"></use>
								</svg>
							</div>
						</div>
					</div>
					<div v-if="isTablet" class="mines__input-mobile">
						<div class="mines__game-controls" :class="[game.active ? 'disabled' : '']">
							<div class="mines__game-control">
								<div class="mines__game-control-title">Бомбы</div>
								<div class="game-controls">
									<select class="custom-select game-controls__input" @change="getMinesRateMobile(bomb)" v-model="bomb">
										<option v-for="i in 23" :value="i + 1" :selected="bomb === (i + 1)">{{ i + 1 }} </option>
									</select>
									<div class="game-controls__items">
										<button @click="getMinesRateMobile(2)" class="game-controls__item">2</button>
										<button @click="getMinesRateMobile(5)" class="game-controls__item">5</button>
										<button @click="getMinesRateMobile(14)" class="game-controls__item">14</button>
										<button @click="getMinesRateMobile(21)" class="game-controls__item">21</button>
									</div>
								</div>
							</div>
							<div class="mines__game-control">
								<div class="mines__game-control-title">Размер игры</div>
								<div class="game-controls">
									<div class="game-controls__bet">
										<input class="game-controls__input"
											   autocomplete="off"
											   placeholder="Сумма"
											   v-model="bet"
											   @keyup="validateBet">
									</div>
									<div class="game-controls__items">
										<button @click="typeBet('max')" class="game-controls__item">Max</button>
										<button @click="typeBet('min')" class="game-controls__item">Min</button>
										<button @click="typeBet('x2')" class="game-controls__item">x2</button>
										<button @click="typeBet('/2')" class="game-controls__item">/2</button>
									</div>
								</div>

							</div>
						</div>
						<div class="mines__buttons">
							<button v-if="!game.active" class="btn btn--primary mines__button" @click="startGameSocket">
								Начать игру
							</button>
							<button v-else-if="game.active && game.active_path <= 1" :class="[game.active ? 'disabled': '']" class="btn btn--primary mines__button">
								Выберите ячейку
							</button>
							<button v-else-if="game.active_path > 1 && game.win && !cashingOut" class="btn btn--success mines__button" @click="cashOut" :class="[(loadBomb > 0 || disableBtnCashout) ? 'disabled': '']">
								Забрать&nbsp<u>{{ (bet * getActiveCoef()).toFixed(2)}}</u>
							</button>
							<button v-if="game.active" class="btn btn--primary mines__button" :class="[(loadBomb > 0 || disableBtnCashout) ? 'disabled': '']" @click="autoSelect">
								Авто
							</button>
							<button v-if="errors.show" class="btn btn--lg btn--danger mines__button">
								{{ errors.message}}
							</button>
						</div>
					</div>
				</div>
				<AllHistory />
            </div>
        </div>
    </div>
</template>

<script>
    import AllHistory from "../../components/History/AllHistory.vue";
	import { mapState } from 'pinia';
	import { useUserStore } from '../../stores/User';
	import { Swiper, SwiperSlide } from 'swiper/vue';
	import RangeSlider from "../../components/blocks/RangeSlider.vue";
	import breakpointsMixin from "../../mixins/breakpoints-mixin.vue";
	import GameNav from "../../components/blocks/GameNav.vue";

    export default {
        components: {
			GameNav,
            AllHistory,
			Swiper,
			SwiperSlide,
			RangeSlider
        },

		mixins: [
			breakpointsMixin
		],

		data() {
            return {
                bet: 1,
                bomb: 3,
                mines: [
                    [[1.01, 1.08], [1.18, 1.30], [1.44, 1.59], [1.78, 2.01], [2.27, 2.60], [3, 3.50], [4.14, 4.96], [6.07, 7.58], [9.75, 13], [18.20, 27.30], [45.50, 91], [273]],
                    [[1.04, 1.18], [1.36, 1.57], [1.84, 2.16], [2.57, 3.08], [3.74, 4.60], [5.75, 7.32], [9.51, 12.69], [17.44, 24.92], [37.37, 59.80], [104.65, 209.3], [523.25, 2093]],
                    [[1.08, 1.30], [1.57, 1.92], [2.38, 2.97], [3.76, 4.84], [6.32, 8.44], [11.50, 16.10], [23.26, 34.88], [54.82, 91.36], [164.45, 328.9], [767.43, 2302.30], [11511.50]],
                    [[1.14, 1.44], [1.84, 2.38], [3.12, 4.16], [5.64, 7.82], [11.07, 16.10], [24.15, 37.56], [61.04, 104.65], [191.86, 383.72], [863.36, 2302.3], [8058.05, 48348.30]],
                    [[1.20, 1.59], [2.16, 2.97], [4.16, 5.94], [8.68, 13.02], [20.13, 32.20], [53.66, 93.92], [174.42, 348.83], [767.43, 1918.58], [5755.75, 23023], [161161]],
                    [[1.26, 1.78], [2.57, 3.76], [5.64, 8.68], [13.74, 22.50], [38.24, 67.98], [127.45, 254.92], [552.32, 1325.57], [3645.31, 12151.03], [54679.62, 437437]],
                    [[1.34, 2.01], [3.08, 4.84], [7.82, 13.02], [22.50, 40.49], [76.48, 152.95], [327.75, 764.75], [1988.35, 5965.05], [21871.85, 109359.25], [984233.25]],
                    [[1.42, 2.27], [3.74, 6.32], [11.07, 20.13], [38.24, 76.48], [162.51, 371.45], [928.63, 2600.15], [8450.49, 33801.95], [185910.73, 1859107.25]],
                    [[1.52, 2.60], [4.60, 8.44], [16.10, 32.20], [67.98, 152.95], [371.45, 990.54], [2971.60, 10400.60], [45069.27, 270415.60], [2974571.60]],
                    [[1.63, 3], [5.75, 11.50], [24.15, 53.66], [127.45, 327.75], [928.63, 2971.6], [11143.5, 52003], [338019.50, 4056234]],
                    [[1.75, 3.50], [7.32, 16.10], [37.56, 93.92], [254.92, 764.75], [2600.15, 10400.60], [52003, 364021], [4732273]],
                    [[1.89, 4.14], [9.51, 23.26], [61.04, 174.42], [552.32, 1988.35], [8450.49, 45069.27], [338019.50, 4732273]],
                    [[2.07, 4.96], [12.69, 34.88], [104.65, 348.83], [1325.57, 5965.05], [33801.95, 270415.60], [4056234]],
                    [[2.27, 6.07], [17.44, 54.82], [191.86, 767.43], [3645.31, 21871.85], [185910.73, 2974571.60]],
                    [[2.53, 7.58], [24.92, 91.36], [383.72, 1918.58], [12151.03, 109359.25], [1859107.25]],
                    [[2.84, 9.75], [37.37, 164.45], [863.36, 5755.75], [54679.62, 984233.25]],
                    [[3.25, 13], [59.8, 328.9], [2302.3, 23023], [437437]],
                    [[3.79, 18.20], [104.65, 767.43], [8058.05, 161161]],
                    [[4.55, 27.30], [209.30, 2302.30], [48348.30]],
                    [[5.69, 45.5], [523.25, 11511.50]],
                    [[7.58, 91], [2093]],
                    [[11.38, 273]],
                    [[22.75]]
                ],
                errors: {
                    show: false,
                    message: ''
                },
                disableBtn: false,
                cashingOut: false,
                game: {
                    active: false,
                    selected_bombs: [],
                    active_path: 0,
                    bombs: [],
                    win: true
                },
                counterBombsBlock: [],
                counterBombs: 0,
                disableBtnBomb: false,
                loadBomb: 0,
                lastLoseGame: {
                    active: false,
                    id: 0
                },
                changeBombs: false,
                disableBtnCashout: false,
				swiper: null
            }
        },
        mounted() {
            if (this.$cookie.get('token')) {
                this.getGame();
            } else {
                this.$root.isLoading = false;
            }
        },
		watch: {
			['game.active_path']() {
				this.scrollToActiveStep();
			}
		},
		computed: {
			...mapState(useUserStore, ['user']),
		},
        methods: {
			autoSelect() {
				let notActive = this.$el.querySelectorAll('.mines-sq')
				notActive[Math.floor(Math.random()*notActive.length)].click()
			},
            validateBet() {
				if (this.bet > 1000000) {
					this.bet = 1000000;
				}

                if (this.user && this.user.balance < this.bet) {
                    this.bet = this.user.balance;
                }

                this.changeBombs = true;
                this.bet = this.bet.toString();
                this.bet = this.bet.replace(/[,]/g, '.').replace(/[^\d,.]*/g, '').replace(/([,.])[,.]+/g, '$1').replace(/^[^\d]*(\d+([.,]\d{0,2})?).*$/g, '$1');
            },
            getMinesRateMobile(bomb) {
				this.validateBet();
                this.bomb = bomb;
            },
			async scrollToActiveStep() {
				setTimeout(() => {
					this.swiper.slideTo(this.game.active_path - 2);
				},1)

			},

			slidePrev() {
				this.swiper.slidePrev();
			},

			slideNext() {
				this.swiper.slideNext();
			},

			onSwiper(inst) {
				this.swiper = inst;
			},
            typeBet(type) {
                switch (type) {
                    case "max":
                        if (this.user !== null) {
                            this.bet = this.user.balance;
                        } else {
                            this.bet = 0;
                        }
                        break;
                    case "min":
                        this.bet = 1;
                        break;
                    case "x2":
						this.bet = this?.user?.balance && this.bet * 2 > +this.user.balance ? this.user.balance : (this.bet * 2).toFixed(2);
                        break;
                    case "/2":
                        this.bet = (this.bet / 2).toFixed(2);
                        break;
                }

                this.validateBet();
            },
            startGameSocket() {
                if (this.disableBtn || this.game.active) {
                    return;
                }

                this.errors.show = false;
                this.disableBtn = true;
                this.disableBtnBomb = false;
                this.disableBtnCashout = false;

                if (!this.$cookie.get('token')) {
                    this.errors = {
                        show: true,
                        message: 'Авторизуйтесь'
                    };

                    this.disableBtn = false;

                    return;
                }

                if (this.bet.length === 0) {
                    this.errors = {
                        show: true,
                        message: 'Введите ставку'
                    };

                    this.disableBtn = false;

                    return;
                }

                if (this.bomb.length === 0) {
                    this.errors = {
                        show: true,
                        message: 'Укажите кол-во бомб'
                    };

                    this.disableBtn = false;

                    return;
                }

                this.$root.axios.post('/api/game/mines/start', {
                    mines: this.bomb,
                    bet: this.bet
                }).then(res => {
                    const data = res.data;

                    this.user.balance = data.balance;
                    this.lastLoseGame.active = false;

                    this.game = {
                        active: true,
                        selected_bombs: [],
                        active_path: 1,
                        bombs: [],
                        win: true
                    };

                    this.changeBombs = false;
                }).catch(error => {
                    this.errors = {
                        show: true,
                        message: this.$root.graphql.axiosGetError(error)
                    };
                });
            },
            setBomb(bomb) {
                if (this.disableBtnBomb) {
                    return;
                }

                this.loadBomb = bomb;
                this.disableBtnBomb = true;
                this.errors.show = false;

                this.$root.axios.post('/api/game/mines/step', {
                    position: bomb
                }).then(res => {
                    const data = res.data;
                    const selectedBombs = data.selected_bombs;

                    this.game.selected_bombs = selectedBombs;
                    this.loadBomb = 0;

                    if (data.win) {
                        this.game.active_path = Object.keys(selectedBombs).length + 1;

                        if (data.insta_win) {
                            this.user.balance += data.amount;
                            this.endGame(data.history);
                        } else {
                            this.disableBtnBomb = false;
                        }
                    } else {
                        this.game.bombs = data.bombs;
                        this.game.win = false;
                        this.game.active = false;

                        this.lastLoseGame = {
                            active: true,
                            id: data.id
                        };
                        this.disableBtn = false;
                    }
                }).catch(error => {
                    this.errors = {
                        show: true,
                        message: this.$root.graphql.axiosGetError(error)
                    };
                });
            },
            setCounterBombKeys(key) {
                if (typeof this.counterBombsBlock[key] === 'undefined') {
                    this.counterBombs++

                    this.counterBombsBlock[key] = this.counterBombs;

                    return this.counterBombsBlock[key];
                } else {
                    return this.counterBombsBlock[key];
                }
            },
            getActiveCoef() {
                let index = 0;
                if ((this.game.active_path - 1) % 2 === 0) index = 1;

                return this.mines[this.bomb - 2][Math.floor((this.game.active_path) / 2) - 1][index];
            },
            cashOut() {
                if (this.disableBtnCashout || this.cashingOut) {
                    return;
                }

                this.disableBtnCashout = true;
                this.cashingOut = true;

                this.$root.axios.post('/api/game/mines/take').then(res => {
                    const data = res.data;

                    this.user.balance += data.amount;

                    this.endGame();
                }).catch(error => {
                    this.errors = {
                        show: true,
                        message: this.$root.graphql.axiosGetError(error)
                    };
                });

                this.disableBtnCashout = false;
                this.cashingOut = false;
            },
            endGame(game) {
                this.errors = {
                    show: false,
                    message: ''
                };
                this.disableBtn = false;
                this.game = {
                    active: false,
                    selected_bombs: [],
                    active_path: 0,
                    bombs: [],
                    win: true
                }
                this.counterBombsBlock = [];
                this.counterBombs = 0;
                this.disableBtnBomb = false;
                this.loadBomb = 0;
                this.lastLoseGame = {
                    active: false,
                    id: 0
                };
                this.changeBombs = false;
                // this.addMyHistory(game);
            },
            getGame() {
                this.$root.graphql.getMinesGame().then(res => {
                    const game = res;

                    if (game.success) {
                        this.disableBtn = true;
                        this.lastLoseGame.active = false;
                        this.changeBombs = false;

                        this.bet = game.bet;
                        this.bomb = game.bomb;


                        this.game = {
                            active: true,
                            selected_bombs: game.selected_bombs,
                            active_path: game.active_path,
                            bombs: [],
                            win: true
                        }
                    }

                    this.$root.isLoading = false;
                }).catch(error => {
                    this.errors = {
                        show: true,
                        message: this.$root.graphql.getError(error)
                    };
                });
            }
        }
    }
</script>
